import { GelTheme } from 'components/GelTheme';
import styled from 'styled-components';
import { QuestionProps, ResponseValueType } from '../types';
import { ConditionalMessages } from './ConditionalMessages';
import { matchesTrigger } from './matchesTrigger';
import { SupportingDocuments } from './SupportingDocuments';

export const Conditionals = styled.div`
  padding-top: ${GelTheme.spacing(1.5)};
  margin-bottom: ${GelTheme.spacing(2.5)};
  display: flex;
  flex-direction: column;
  gap: ${GelTheme.spacing(1.5)};

  *[class^='StyledInPageAlert'] {
    margin: 0;
  }
`;

export type QuestionConditionalProps<TValue extends ResponseValueType = boolean> = Pick<
  QuestionProps<TValue>,
  'conditionalMessages' | 'supportingDocuments'
> & {
  value: TValue[] | TValue | null;
};

export const QuestionConditionals = <TValue extends ResponseValueType = boolean>({
  value,
  conditionalMessages,
  supportingDocuments,
}: QuestionConditionalProps<TValue>) => {
  const triggeredMessages = conditionalMessages?.filter((c) => matchesTrigger(c, value));
  const triggeredDocuments = supportingDocuments?.filter((d) => matchesTrigger(d, value));

  const hasConditionals = triggeredMessages?.length > 0 || triggeredDocuments?.length > 0;
  if (!hasConditionals) return null;

  return (
    <Conditionals>
      <ConditionalMessages value={value} messages={triggeredMessages} />
      <SupportingDocuments value={value} documents={triggeredDocuments} />
    </Conditionals>
  );
};

QuestionConditionals.defaultProps = {
  vertical: true,
  optional: false,
};
